import React, { FC } from 'react';
import { HKLogo } from '../Images';
import classes from './SpinHeader.module.css';

const SpinHeader: FC = () => (
  <div className={classes.root}>
    <img src={HKLogo} alt="Helzberg" className={classes.logo} />
    <p className={classes.tagline}>THE RING BUILDER CHALLENGE</p>
  </div>
);

export default SpinHeader;
